<div class="d-flex flex-grow-1 flex-column">
  <router-outlet></router-outlet>
</div>
